if (!customElements.get('sticky-add-to-cart')) {
  customElements.define(
    'sticky-add-to-cart',
    class StickyAddToCart extends HTMLElement {
      constructor() {
        super();
        this.sectionId = this.dataset.sectionId;
        this.targetButtonId = this.dataset.targetButton;
        this.stickyButton = this.querySelector(`#StickyAddToCart-${this.sectionId}`);
        this.priceWrapper = this.querySelector(`#StickyPrice-${this.sectionId}`);
      }

      connectedCallback() {
        this.targetButton = document.getElementById(this.targetButtonId);

        this.setupVisibilityObserver();
        this.setupClickHandler();
        this.setupButtonStateSync();
        this.setupVariantChangeListener();
      }

      disconnectedCallback() {
        if (this.visibilityObserver) this.visibilityObserver.disconnect();
        if (this.buttonStateObserver) this.buttonStateObserver.disconnect();
        if (typeof this.unsubscribeVariantChange === 'function') this.unsubscribeVariantChange();
      }

      // Show the bar once the real add-to-cart button scrolls out of view,
      // hide it again once the button is back on screen.
      setupVisibilityObserver() {
        if (!this.targetButton || !('IntersectionObserver' in window)) {
          this.classList.add('sticky-add-to-cart--visible');
          return;
        }

        this.visibilityObserver = new IntersectionObserver(
          (entries) => {
            const isTargetVisible = entries[0].isIntersecting;
            this.classList.toggle('sticky-add-to-cart--visible', !isTargetVisible);
          },
          { rootMargin: '0px', threshold: 0 }
        );
        this.visibilityObserver.observe(this.targetButton);
      }

      // Never talk to the Cart API ourselves — just trigger the real button's
      // click so we inherit Dawn's existing add-to-cart / cart-drawer / error
      // handling untouched.
      setupClickHandler() {
        if (!this.stickyButton) return;

        this.stickyButton.addEventListener('click', (event) => {
          event.preventDefault();

          this.targetButton = document.getElementById(this.targetButtonId) || this.targetButton;
          if (this.targetButton && !this.targetButton.disabled) {
            this.targetButton.click();
          }
        });
      }

      // Keep disabled state, label text ("Add to cart" / "Sold out" /
      // loading spinner) in sync with the real button at all times.
      setupButtonStateSync() {
        if (!this.targetButton || !this.stickyButton) return;

        const syncState = () => {
          this.stickyButton.disabled = this.targetButton.disabled;
          this.stickyButton.classList.toggle('loading', this.targetButton.classList.contains('loading'));

          const targetLabel = this.targetButton.querySelector('span');
          const stickyLabel = this.stickyButton.querySelector('span');
          if (targetLabel && stickyLabel) {
            stickyLabel.textContent = targetLabel.textContent;
          }
        };

        syncState();

        this.buttonStateObserver = new MutationObserver(syncState);
        this.buttonStateObserver.observe(this.targetButton, {
          attributes: true,
          attributeFilter: ['disabled', 'class'],
          childList: true,
          subtree: true,
        });
      }

      // Optional: keep the sticky price in sync when the shopper switches
      // variants. Relies on Dawn's global pub/sub (global.js). Safe no-op on
      // themes that don't expose it — button label/availability still sync
      // via the MutationObserver above regardless.
      setupVariantChangeListener() {
        if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

        this.unsubscribeVariantChange = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          if (!event || !event.data || event.data.sectionId !== this.sectionId) return;

          if (this.priceWrapper && event.data.html) {
            const sourcePrice = event.data.html.querySelector(`#price-${this.sectionId}`);
            if (sourcePrice) this.priceWrapper.innerHTML = sourcePrice.innerHTML;
          }

          // The buy-buttons block can be re-rendered on variant change in
          // some themes; re-grab the button reference just in case.
          this.targetButton = document.getElementById(this.targetButtonId) || this.targetButton;
        });
      }
    }
  );
}